import { publicClient, privateClient } from './client';
import { Store } from './Store';

const transactionsStore = (pub: boolean) => new Store(pub ? publicClient : privateClient);
export default transactionsStore;
